import { http } from '../client';
import type { CallOptions, WriteOptions } from '../types';
import type { DossierQueueApi } from './dossierQueue';

// Paths mirror subsystems/identity/facade/adapters/admin-api/src/admin/dossier_queue.rs.
const seg = encodeURIComponent;
const rd = (o?: CallOptions) => ({ signal: o?.signal });
const wr = (o?: WriteOptions) => ({ signal: o?.signal, idempotencyKey: o?.idempotencyKey, notifyCustomer: o?.notifyCustomer });

export const dossierQueueHttp: DossierQueueApi = {
  listDossierQueue: (query, opts) => http.get('api', '/dossier-queue', { query: { ...query }, ...rd(opts) }),
  dossierQueueSummary: (opts) => http.get('api', '/dossier-queue/summary', rd(opts)),
  getDossierQueueItem: (id, opts) => http.get('api', `/dossier-queue/${seg(id)}`, rd(opts)),
  remindDossier: (id, body, opts) => http.post('api', `/dossier-queue/${seg(id)}/remind`, body, wr(opts)),
  addDossierNote: (id, body, opts) => http.post('api', `/dossier-queue/${seg(id)}/notes`, body, wr(opts)),
  uploadDossierFile: (id, body, opts) => http.post('api', `/dossier-queue/${seg(id)}/files`, body, wr(opts)),
  setDossierCase: (id, body, opts) => http.post('api', `/dossier-queue/${seg(id)}/case`, body, wr(opts)),
  listDossierUploadTypes: (id, opts) => http.get('api', `/dossier-queue/${seg(id)}/upload-types`, rd(opts)),
  // subsystems/identity/facade/adapters/admin-api/src/admin/document_types.rs
  listDossierDocumentTypes: (opts) => http.get('api', '/dossier-document-types', rd(opts)),
  updateDossierDocumentType: (id, body, opts) => http.put('api', `/dossier-document-types/${seg(id)}`, body, wr(opts)),
};
